/*
   본 소프트웨어는 관련 법률에 따라 보호되는 삼성의 지식재산 및 영업비밀 입니다. 본 소프트웨어를 권한 없이 사용하거나 삼성의 사전 서면 동의 없이 제3자에게 공개하는 행위는
   엄격히 금지되어 있으며 위반 시 귀하는 무단 사용 또는 비밀 유지 의무 위반에 대해 법적인 책임을 져야 합니다. This software is the intellectual
   property and confidential information of Samsung Electronics, Co., Ltd. (“Samsung”) protected by
   applicable laws. The unauthorized use or disclosure of the software to any third party without
   the prior written consent of Samsung is strictly prohibited, and you should be legally
  responsible for the unauthorized use or violation of confidentiality obligation.
*/
/**
 * Program: SDL Common Component
 * Author: SDL
 * Description: SDL Common Component
 */
import SdlBreadcrumb from './breadcrumb';
import SdlLoadingbar from './loadingbar/LoadingBar';
import SdlModal from './modal';
import SdlFileuploader from './fileuploader/MultipleFileUploader';
import SdlDatePicker from './datepicker';
import SdlRegexInput from './input/RegexInput';
import SdlTabsPlugin from './tabs';
import sdlPagination from './pagination/Pagination';
import { SdlExceldownload, SdlExcelupload, WijmoExceldownload, WijmoExcelupload, SpreadJsExcelDownload } from './excel';
import SdlTree from './tree';
import SdlApprovalpath from './approvalpath/ApprovalPath';
import SdlQuarterCondition from './quarterCondition/QuarterCondition';
import SdlMonthCondition from './monthCondition/MonthCondition';

const SdlControl = {
  // eslint-disable-next-line no-unused-vars
  install(Vue, options) {
    Vue.use(SdlModal, {
      dialog: true,
      dynamic: true,
      dynamicDefaults: { clickToClose: false },
      injectModalsContainer: true,
    });

    Vue.use(SdlTabsPlugin);

    Vue.component('sdl-breadcrumb', SdlBreadcrumb);
    Vue.component('sdl-loadingbar', SdlLoadingbar);
    Vue.component('sdl-fileuploader', SdlFileuploader);
    Vue.component('sdl-datepicker', SdlDatePicker);
    Vue.component('sdl-pagination', sdlPagination);
    Vue.component('sdl-exceldownloadbtn', SdlExceldownload);
    Vue.component('sdl-exceluploadbtn', SdlExcelupload);
    Vue.component('wijmo-exceldownloadbtn', WijmoExceldownload);
    Vue.component('wijmo-exceluploadbtn', WijmoExcelupload);
    Vue.component('sdl-tree', SdlTree);
    Vue.component('sdl-approvalpath', SdlApprovalpath);
    Vue.component('sdl-regex-input', SdlRegexInput);
    Vue.component('sdl-quarter-condition', SdlQuarterCondition);
    Vue.component('sdl-month-condition', SdlMonthCondition);
    Vue.component('spread-js-exceldownloadbtn', SpreadJsExcelDownload);
    // Exclude Editor from SDL common component related to license
    // Vue.component('sdl-editor', SdlEditor);
  },
};

export default SdlControl;



// WEBPACK FOOTER //
// ./src/components/common/control/index.js